function a0_0x5058() {
  const _0x43953c = [
    "userAgent","instantiate","DateTimeFormat","encode","timeZone","Abortado",
    "19534680bDOUwp","210YxknVO","3564204dOEvlm","PBKDF2","subarray","exports",
    "buffer","2364LNZZuu","734063FwQgBa","subtle","4musYze","18HNqaFv","12agWtUa",
    "595892sQbIJh","toString","5180744xLhFas","error","from","deriveBits",
    "join","402939HSptEZ","unknown","655ZKOXno","colorDepth","screen","raw"
  ];
  a0_0x5058 = () => _0x43953c;
  return _0x43953c;
}

function a0_0x2799(_0x4508fa, _0x1ce63a) {
  const _0x505872 = a0_0x5058();
  return (
    (a0_0x2799 = function (_0x279930, _0x2b8143) {
      _0x279930 = _0x279930 - 0x15a;
      return _0x505872[_0x279930];
    }),
    a0_0x2799(_0x4508fa, _0x1ce63a)
  );
}


;(function (_0x83bc7d, _0x32026a) {
  const _0x129d4a = a0_0x2799,
        _0x3665d3 = _0x83bc7d();
  while (true) {
    try {
      const _0x1002cc =
        -parseInt(_0x129d4a(0x16d))/0x1 * -parseInt(_0x129d4a(0x16f))/0x2
        + -parseInt(_0x129d4a(0x179))/0x3 * (parseInt(_0x129d4a(0x171))/0x4)
        + parseInt(_0x129d4a(0x15b))/0x5 * (parseInt(_0x129d4a(0x16c))/0x6)
        + parseInt(_0x129d4a(0x167))/0x7
        + -parseInt(_0x129d4a(0x174))/0x8 * (parseInt(_0x129d4a(0x170))/0x9)
        + -parseInt(_0x129d4a(0x166))/0xa * (parseInt(_0x129d4a(0x172))/0xb)
        + parseInt(_0x129d4a(0x165))/0xc;
      if (_0x1002cc === _0x32026a) break;
      _0x3665d3.push(_0x3665d3.shift());
    } catch (_0x2e3abc) {
      _0x3665d3.push(_0x3665d3.shift());
    }
  }
})(a0_0x5058, 0xc8749);


export const loadWasm = async function() {
  const _0x235d2b = a0_0x2799,
        _0xecbdd9 = await fetch('/dorado.wasm'),
        _0x59f758 = await _0xecbdd9['arrayBuffer']();

  const wasmMemory = new WebAssembly.Memory({ initial: 256, maximum: 512 });
  const wasmTable  = new WebAssembly.Table({ initial: 1, element: 'anyfunc' });

  const { instance: _0x48e19e } = await WebAssembly[_0x235d2b(0x160)](
    _0x59f758,
    {
      env: {
        abort: () => console[_0x235d2b(0x175)](_0x235d2b(0x164)),
        memory: wasmMemory,
        table:  wasmTable
      }
    }
  );

  const { memory: _0x5d4e8b, elDorado: _0x3f051c } =
    _0x48e19e[_0x235d2b(0x16a)];
  const _0x290768 = (typeof _0x3f051c === 'function' ? _0x3f051c() : 0) || 0;
  const _0x49115d = new Uint8Array(
    _0x5d4e8b[_0x235d2b(0x16b)], _0x290768, 0x40
  );
  const _0x231e02 = _0x49115d['indexOf'](0x0);
  const _0x52b80d = new TextDecoder()['decode'](
    _0x49115d[_0x235d2b(0x169)](0x0, _0x231e02)
  );
  const _0x1e66f5 = Intl[_0x235d2b(0x161)]()['resolvedOptions']()[_0x235d2b(0x163)] || _0x235d2b(0x15a);
  const _0xd1260c = navigator[_0x235d2b(0x15f)] || _0x235d2b(0x15a);
  const _0x5a17d1 = window[_0x235d2b(0x15d)][_0x235d2b(0x15c)] || 'unknown';
  const _0x189a23 = _0x1e66f5 + '|' + _0xd1260c + '|' + _0x5a17d1;
  const _0x37d72e = new TextEncoder();
  const _0x249fcc = _0x37d72e['encode'](_0x52b80d);
  const _0x4dcbdd = await crypto['subtle']['importKey'](
    _0x235d2b(0x15e),
    _0x37d72e[_0x235d2b(0x162)](_0x189a23),
    { name: 'PBKDF2' },
    false,
    [_0x235d2b(0x177)]
  );
  const _0x5065eb = await crypto[_0x235d2b(0x16e)][_0x235d2b(0x177)](
    {
      name: _0x235d2b(0x168),
      salt: _0x249fcc,
      iterations: 0x249f0,
      hash: 'SHA-256'
    },
    _0x4dcbdd,
    0x100
  );
  const _0x22fe9f = Array[_0x235d2b(0x176)](new Uint8Array(_0x5065eb))
    ['map'](_0x257cfe =>
      _0x257cfe[_0x235d2b(0x173)](0x10)['padStart'](0x2, '0')
    )[_0x235d2b(0x178)]('');

  return _0x22fe9f;
};
